import Const from 'const';

export interface FilterTierInterface {
    getKey(): string;
    getValue(): string | any[];
    isKeyEqual(key: string): boolean;
}

export class FilterTier implements FilterTierInterface {
    readonly key: string;
    readonly value: string | any[];
    constructor(key: string, value: string | any[]) {
        this.key = key;
        this.value = value;
    }
    getKey(): string {
        return this.key;
    }
    getValue(): string | any[] {
        return this.value;
    }
    isKeyEqual(key: string): boolean {
        return this.key === key;
    }
}

export function createOverallFilterTier(): FilterTierInterface {
    return new FilterTier(Const.OVERALL_MODE, Const.OVERALL_MODE);
}

export function isOverallFilterTier(filterTier: FilterTierInterface): boolean {
    return Const.OVERALL_MODE === filterTier.getKey();
}

export function createFilterTier(tierNumber: number): FilterTierInterface {
    return new FilterTier(String(tierNumber), [tierNumber]);
}
